import { Category } from "../types/category";
import { createApiStore } from "./genericStore";
 
export const useCategoryStore = createApiStore<Category>("/categories");
